import styled from "styled-components";
import { Link as LinkS} from 'react-scroll';


export const Nav = styled.nav`
    background: rgba(0, 0, 0, 1);
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5em;
    position: fixed;
    z-index: 999;
    width: 100%;


    @media screen and (max-width: 1023px){
        transition: 0.8s all ease; 
    }
`;

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
`;

export const NavLogo = styled(LinkS)`
    color: #4e9eff;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5em;
    display: flex;
    align-items: center;
    margin-left: 24px;
    font-weight: bold;
    text-decoration: none;

    &:hover{
        color: #fff;
    }

    &.active{
        color: #fff;
    }
`;



export const MobileIcon = styled.div`
    display: none;

    @media screen and (max-width: 768px){
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-100%, 60%);
        font-size: 1.5rem;
        cursor: pointer;
        color: #fff;
    }
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: -22px;

        

    @media screen and (max-width: 768px){
        display: none;
    }
`;

export const NavItems = styled.li`
    height: 80px;
`;

export const NavLinks = styled(LinkS)`
    color: #4e9eff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1em;
    height: 100%;
    cursor: pointer;



    &:hover{
        color: #fff;
    }
`;